import withNavigate from "../../../routes/withNavigate.jsx";
import TrackingContainer from "./TrackingContainer.jsx";
import TrackingStore from "./TrackingStore.js";

export default TrackingStore(withNavigate(TrackingContainer));